<template>
  <div style="display: none;">
    <!-- 結構化資料會在這裡渲染 -->
  </div>
</template>

<script>
export default {
  name: 'SEOStructuredData',
  props: {
    type: {
      type: String,
      default: 'website'
    },
    data: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.addStructuredData()
  },
  updated() {
    this.addStructuredData()
  },
  methods: {
    addStructuredData() {
      // 移除舊的結構化資料
      const existingScripts = document.querySelectorAll('script[data-structured-data="true"]')
      existingScripts.forEach(script => script.remove())
      
      // 添加新的結構化資料
      const script = document.createElement('script')
      script.type = 'application/ld+json'
      script.setAttribute('data-structured-data', 'true')
      script.textContent = JSON.stringify(this.data)
      document.head.appendChild(script)
    }
  },
  watch: {
    data: {
      handler() {
        this.addStructuredData()
      },
      deep: true
    }
  }
}
</script> 